
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.535 25.828a14.61 14.61 0 00-3.148-4.668 14.673 14.673 0 00-4.668-3.148c-.016-.008-.032-.012-.047-.02a9.667 9.667 0 004.015-7.851A9.686 9.686 0 0015 .453a9.686 9.686 0 00-9.688 9.688 9.68 9.68 0 004.016 7.855c-.015.008-.031.012-.047.02a14.546 14.546 0 00-4.668 3.148 14.673 14.673 0 00-3.148 4.668 14.522 14.522 0 00-1.153 5.395.313.313 0 00.313.32h2.344a.312.312 0 00.312-.305 11.646 11.646 0 013.43-7.98A11.641 11.641 0 0115 19.828c3.133 0 6.074 1.219 8.29 3.434a11.646 11.646 0 013.429 7.98.31.31 0 00.312.305h2.344a.313.313 0 00.313-.32 14.558 14.558 0 00-1.153-5.399zM15 16.86a6.677 6.677 0 01-4.75-1.968 6.675 6.675 0 01-1.969-4.75c0-1.793.7-3.48 1.969-4.75A6.675 6.675 0 0115 3.42c1.793 0 3.48.7 4.75 1.97a6.675 6.675 0 011.969 4.75c0 1.793-.7 3.48-1.969 4.75A6.675 6.675 0 0115 16.859z","fill":"#FFF"}})])
          )
        }
      }
    